import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { combineLatest, Observable, of } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { AppointmentPurpose } from 'src/app/samwebDescription/samwin/AppointmentPurpose';
import { FeatureEnum } from 'src/app/samwebDescription/samwin/FeatureEnum';
import { CloseAppointmentDialog, SetCurrentView } from 'src/app/store/samwin/appointment-dialog/appointment-dialog.actions';
import { AppointmentDialogState } from 'src/app/store/samwin/appointment-dialog/appointment-dialog.state';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';
import { AppointmentEntryRemoteDto } from 'src/generated/signalR/appointment-entry-remote-dto';
import { DirectoryEntryRemoteDto } from 'src/generated/swagger';

@Component({
   selector: 'samweb-appointment-scheduler-dialog',
   templateUrl: './appointment-scheduler-dialog.component.html',
   styleUrls: ['./appointment-scheduler-dialog.component.scss'],
})
export class AppointmentSchedulerDialogComponent implements OnInit {
   @Select(AppointmentDialogState.isAppointmentSchedulerOpen)
   public isAppointmentOpen$: Observable<boolean>;

   @Select(AppointmentDialogState.getAppointmentsOfSelectedDirectoryEntry)
   public selectedAppointments$: Observable<AppointmentEntryRemoteDto[]>;

   @Select(AppointmentDialogState.getPurpose)
   public purpose$: Observable<AppointmentPurpose>;

   @Select(AppointmentDialogState.currentDirectoryEntry)
   public directoryEntry$: Observable<DirectoryEntryRemoteDto>;

   @Select(AppointmentDialogState.getCurrentView)
   public currentView$: Observable<number>;

   @Select(AppointmentDialogState.getShowBusinessHours)
   public showBusinessHours$: Observable<boolean>;

   public doShowExchangeAppointmentSubjects$: Observable<boolean>;

   public dialogTitle$: Observable<string>;

   constructor(private store: Store, private translateService: TranslateService) {}

   ngOnInit(): void {
      this.doShowExchangeAppointmentSubjects$ = this.store.select(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.DO_SHOW_EXCHANGE_APPOINTMENT_SUBJECTS));

      this.dialogTitle$ = combineLatest([
         this.purpose$.pipe(switchMap((purpose) => this.translateService.get(purpose.titlebarText))),
         this.directoryEntry$,
      ]).pipe(
         take(1),
         switchMap(([title, directoryEntry]) => {
            // fixme: The name of a subscriber is not only the "orgnam" column,
            // but can contain multiple other columns(configurable)
            let name = directoryEntry?.orgnam;
            if (_.isEmpty(name)) {
               name = directoryEntry?.orgnum;
            }
            return of(_.isEmpty(name) ? title : title + ' - ' + name);
         })
      );
   }

   cancel(): void {
      this.store.dispatch(new CloseAppointmentDialog());
   }

   onViewIndexChange(e: number): void {
      this.store.dispatch(new SetCurrentView(e));
   }
}
